import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = "/api";

export const productApi = createApi({
  reducerPath: "productApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    SaveProjuct: builder.mutation({
      query: ({ token, data }) => ({
        url: "/project",
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: data,
      }),
      // Use 'Projects' for providesTags and invalidatesTags
      providesTags: ["Projects"],
      invalidatesTags: ["Projects"],
    }),
    GetProject: builder.query({
      query: (id) => ({
        url: `/project/${id}`,
        method: "GET",
      }),
      // Use 'Projects' for providesTags
      providesTags: (result, error, id) => [{ type: "Projects", id }],
    }),
    getAllProject: builder.query({
      query: ({ token }) => ({
        url: "/project",
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      providesTags: ["Projects"],
      invalidatesTags: ["Projects", "Project"],
    }),
    UpadteProject: builder.mutation({
      query: ({ projectId, Token, data }) => ({
        url: `/project/${projectId}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: data,
      }),
      // Use 'Projects' for invalidatesTags
      invalidatesTags: ["Projects"],
    }),
    DeleteProject: builder.mutation({
      query: ({ projectId, Token }) => ({
        url: `/project/${projectId}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      // Use 'Projects' for invalidatesTags
      invalidatesTags: ["Projects"],
    }),
  }),
});

export const {
  useSaveProjuctMutation,
  useGetProjectQuery,
  useUpadteProjectMutation,
  useDeleteProjectMutation,
  useGetAllProjectQuery,
} = productApi;
